// a pixel component that renders nothing but tracks analytics events
import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { IStore } from 'src/explore/types/store';

import { initializeSegment } from './services/segment';

const AnalyticsPixel = () => {
  const meta = useSelector(( state: IStore ) => state.data.account.meta );

  useEffect(() => {
    if ( meta ) {
      initializeSegment( meta );
    }
  }, [ meta ]);

  return <></>;
};

export default AnalyticsPixel;
